<ng-container
  *ngIf="{
    model: model$ | async,
  } as content"
>
  <div *ngIf="!isInfiniteScroll" class="cx-pagination">
    <cx-custom-pagination [pagination]="content.model?.pagination" queryParam="currentPage" [defaultPage]="0"></cx-custom-pagination>
  </div>
</ng-container>
